import React, { useRef } from 'react';
import './EventsListingCard.css'
import offerPopImage from "./image/offer-pops-image.svg"
import { IoShareSocialOutline } from "react-icons/io5";
import { FaRegBookmark } from "react-icons/fa";

import { FaCalendarAlt, FaClock, FaMapMarkerAlt, FaRupeeSign, FaStar, FaDoorOpen } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { add } from 'date-fns';

const EventsListingCard = ({
    title,
    date,
    clubName,
    areaName,
    time,
    rating,
    location,
    distance,
    type,
    price,
    image,
    offer,
    eventid,
    clubid,
    isEventThankyou
}) => {



    const cardRef = useRef(null);
    const imageRef = useRef(null);
    // Method 1: Direct download via fetch (works for most images)
    const downloadImageDirect = async () => {
        try {
            const response = await fetch(image);
            const blob = await response.blob();

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${title?.replace(/\s+/g, '-').toLowerCase() || 'event-image'}.jpg`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Direct download failed:', error);
            // Fallback to Method 2
            downloadImageWithProxy();
        }
    };

    // Method 2: Using a CORS proxy
    const downloadImageWithProxy = () => {
        const proxyUrl = `https://api.allorigins.win/raw?url=${encodeURIComponent(image)}`;
        const img = new Image();
        img.crossOrigin = 'anonymous';

        img.onload = () => {
            const padding = 100; // Increased padding for title + link
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = img.width;
            canvas.height = img.height + padding;

            // Fill background
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Draw title background
            ctx.fillStyle = "#f8f8f8";
            ctx.fillRect(0, 0, canvas.width, padding);

            // Draw title text
            ctx.fillStyle = "#000000";
            ctx.font = "bold 24px Arial";
            ctx.textAlign = "center";
            ctx.fillText(title || "Event Title", canvas.width / 2, 35);

            // Draw link text below title
            const eventLink = "https://partywitty.com"; // 🔗 Change to your actual link
            ctx.font = "16px Arial";
            ctx.fillStyle = "#0077cc"; // Link color
            ctx.fillText(eventLink, canvas.width / 2, 65);

            // Draw the image below the text
            ctx.drawImage(img, 0, padding);

            // Trigger download
            canvas.toBlob((blob) => {
                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `${title?.replace(/\s+/g, '-').toLowerCase() || 'event-image'}.jpg`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(downloadUrl);
            }, 'image/jpeg', 0.9);
        };

        img.onerror = () => {
            console.error("Proxy image load failed.");
        };

        img.src = proxyUrl;
    };


    // Method 3: Convert to canvas and download (bypasses some CORS issues)
    const downloadImageAsDataURL = async () => {
        try {
            const img = imageRef.current;
            if (!img) return;

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;

            ctx.drawImage(img, 0, 0);

            canvas.toBlob((blob) => {
                if (blob) {
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `${title?.replace(/\s+/g, '-').toLowerCase() || 'event-image'}.jpg`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                }
            }, 'image/jpeg', 0.9);

        } catch (error) {
            console.error('Canvas download failed:', error);
            // Fallback to Method 4
            downloadImageSimple();
        }
    };

    // Method 4: Simple link approach (opens in new tab for download)
    const downloadImageSimple = () => {
        const link = document.createElement('a');
        link.href = image;
        link.download = `${title?.replace(/\s+/g, '-').toLowerCase() || 'event-image'}.jpg`;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Method 5: Using XMLHttpRequest (alternative to fetch)
    const downloadImageXHR = () => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', image, true);
        xhr.responseType = 'blob';

        xhr.onload = function () {
            if (xhr.status === 200) {
                const blob = xhr.response;
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${title?.replace(/\s+/g, '-').toLowerCase() || 'event-image'}.jpg`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
        };

        xhr.onerror = function () {
            console.error('XHR download failed');
            downloadImageSimple(); // Final fallback
        };

        xhr.send();
    };

    // Smart download function that tries multiple methods
    const smartDownloadImage = async () => {
        try {
            const response = await fetch(image, { mode: 'cors' });
            const blob = await response.blob();
            const img = new Image();

            img.crossOrigin = 'anonymous';
            const url = URL.createObjectURL(blob);

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // Set canvas size to image size
                canvas.width = img.width;
                canvas.height = img.height + 60; // extra space for title

                // Draw the image
                ctx.drawImage(img, 0, 60);

                // Add title text
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, canvas.width, 60); // Background for text

                ctx.fillStyle = '#000';
                ctx.font = 'bold 24px Arial';
                ctx.textAlign = 'center';
                ctx.fillText(clubName || 'Event Title', canvas.width / 2, 40);

                // Draw image below title

                // Download
                canvas.toBlob((newBlob) => {
                    const downloadUrl = URL.createObjectURL(newBlob);
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = `${title?.replace(/\s+/g, '-').toLowerCase() || 'event-image'}.jpg`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(downloadUrl);
                    URL.revokeObjectURL(url);
                }, 'image/jpeg', 0.9);
            };

            img.onerror = () => {
                console.error('Image load failed');
                downloadImageWithProxy();
            };

            img.src = url;
        } catch (error) {
            console.error('Smart download failed:', error);
            downloadImageWithProxy(); // fallback
        }
    };


    function exportCanvas(canvas, titleText) {
        canvas.toBlob((blob) => {
            const fileName = `${titleText.replace(/\s+/g, '-').toLowerCase()}.jpg`;
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url);
        }, 'image/jpeg', 0.95);
    }

    function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
        const words = text.split(' ');
        let line = '';

        for (let n = 0; n < words.length; n++) {
            const testLine = line + words[n] + ' ';
            const metrics = ctx.measureText(testLine);
            if (metrics.width > maxWidth && n > 0) {
                ctx.fillText(line, x, y);
                line = words[n] + ' ';
                y += lineHeight;
            } else {
                line = testLine;
            }
        }
        ctx.fillText(line, x, y);
    }

    function drawRoundedRect(ctx, x, y, width, height, radius) {
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.fill();
    }


   const downloadAndShare = () => {
    const proxyUrl = `https://api.allorigins.win/raw?url=${encodeURIComponent(image)}`;
    const img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0);

        const padding = 80;
        const radius = 20;

        // Club Name Box
        ctx.font = 'bold 60px Arial';
        const clubText = clubName || "Event Title";
        const clubTextWidth = ctx.measureText(clubText).width;
        const boxWidth = clubTextWidth + padding;
        const boxHeight = 80;
        const boxX = (canvas.width - boxWidth) / 2;
        const clubBoxY = 60;

        ctx.fillStyle = '#ccff00';
        drawRoundedRect(ctx, boxX, clubBoxY, boxWidth, boxHeight, radius);

        ctx.fillStyle = '#000';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle'; // ⬅️ Vertical centering
        ctx.font = 'bold 60px Arial';
        ctx.fillText(clubText, canvas.width / 2, clubBoxY + boxHeight / 2);

        // Address Box
        ctx.font = '50px Arial';
        const addressText = `📍 ${areaName || "Club Address"}`;
        const addressTextWidth = ctx.measureText(addressText).width;
        const addressBoxWidth = addressTextWidth + padding;
        const addressBoxX = (canvas.width - addressBoxWidth) / 2;
        const addressBoxY = clubBoxY + boxHeight + 20;

        ctx.fillStyle = '#ccff00';
        drawRoundedRect(ctx, addressBoxX, addressBoxY, addressBoxWidth, boxHeight, radius);

        ctx.fillStyle = '#000';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = '50px Arial';
        ctx.fillText(addressText, canvas.width / 2, addressBoxY + boxHeight / 2);

        // Logo Overlay
        const logoImg = new Image();
        logoImg.crossOrigin = 'anonymous';
        logoImg.src = 'https://res.cloudinary.com/dgviyqmaz/image/upload/v1753092993/logo_n9mj83.png';

        logoImg.onload = () => {
            const logoWidth = 120;
            const logoHeight = 60;
            const logoX = 30;
            const logoY = canvas.height - logoHeight - 30;
            ctx.drawImage(logoImg, logoX, logoY, logoWidth, logoHeight);
            exportCanvas(canvas, title || "event-image");
        };

        logoImg.onerror = () => {
            console.warn("Logo failed to load, proceeding without it.");
            exportCanvas(canvas, title || "event-image");
        };
    };

    img.onerror = () => {
        console.error("Main image failed to load.");
    };

    img.src = proxyUrl;
};








    return (
        <div className="event-card-container" ref={cardRef}>
            <div className="event-card-image-wrapper">
                <div className="event-card-image-overlay-bg"></div>
                <img
                    src={image}
                    alt="Percussion Night"
                    className="event-card-image"
                />
                {offer && (
                    <img className='offer-pop' src={offerPopImage} alt="offer-pop-image" />
                )}

                {isEventThankyou && (
                    <>
                        <div className='event-card-image-overlay-event-thankyou-tag'>
                            <p>My Choice</p>
                        </div>
                    </>
                )}
                <div className="event-card-actions">
                    <span className="event-card-action-btn"><FaRegBookmark /></span>
                    <span
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            // downloadAndShare();
                        }}
                        className="event-card-action-btn"
                    >
                        <IoShareSocialOutline />
                    </span>
                </div>
                {offer && (
                    <div className="event-card-image-offer-overlay">
                        <div className="event-card-image-offer-box">
                            <p>{offer}</p>
                        </div>
                    </div>
                )}

            </div>
            <div className="event-card-details">
                <h3 className="event-card-title">
                    {title?.length > 27 ? title?.slice(0, 27) + '...' : title}
                </h3>
                <div className="event-card-meta">
                    <div className='event-card-time-date'>
                        <span>
                            <FaCalendarAlt /> {date}
                        </span>
                        <span>
                            <FaClock /> {time}
                        </span>
                    </div>
                    <div className='event-card-rating'>
                        <span>
                            <FaStar /> {rating}
                        </span>
                    </div>
                </div>
                <div className="event-card-location">
                    <span>
                        <FaMapMarkerAlt /> {location}
                    </span>
                    <span className="event-card-distance">{distance}</span>
                </div>
                <div className="event-card-extra">
                    <div className='event-card-type-price'>
                        <span>
                            <FaDoorOpen /> {type}
                        </span>
                        <span>
                            {price > 0 && <FaRupeeSign />} {price > 0 && price}
                        </span>
                    </div>

                    {!isEventThankyou && (
                        <Link to={`/event-book/${clubid}/${eventid}`} style={{ textDecoration: "none" }}>
                            <div className='event-card-button'>
                                <button>Book Now</button>
                            </div>
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EventsListingCard;

